import { render } from "./Notifications.vue?vue&type=template&id=409e8ef6"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Notifications.vue?vue&type=style&index=0&id=409e8ef6&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script